import { LOGOUT as t, LOGIN as i } from "./types.js";
const s = {
  isLoggedIn: !1,
  username: "",
  di_code: "",
  isValidUser: !1
};
function n(e = s, r) {
  switch (r.type) {
    case i:
      return {
        ...e,
        ...r.payload,
        isLoggedIn: !0
      };
    case t:
      return s;
    default:
      return e;
  }
}
export {
  n as userReducer
};
//# sourceMappingURL=reducers.js.map
